<template><div>

	<div class="tab-pane-plan-wrapper">

		<!-- блок с локальным сообщением об ошибке -->
		<transition name="fadeControl" key="transitionError">
			<div v-show="localErrorMessage !== ''" class="alert alert-danger margin-20-0" role="alert">
				<button @click="localErrorMessage = ''" class="close" :title="'main/close' | ftc">×</button>
				<span style="padding:0;margin:0;" v-withSafeTags="localeFtc(localErrorMessage)"></span>
			</div>
		</transition>

		<!-- если запущен процесс или нет доступа -->
		<template v-if="!Access">
			<div class="text-center margin-top-5">
				<div v-if="serviceStatus && (serviceStatus.loader || serviceStatus.timer)" style="margin: 80px auto">
					<span v-if="serviceStatus['loader']" class="margin-right-10 font-weight-500 font-size-120" :class="'w5-status-color-' + status">{{ serviceStatus['status'] | capitalize }} <img src="../../assets/img/loading-hor16.gif" style="margin-left: 6px" /></span>
					<span v-else-if="serviceStatus['timer']" class="margin-right-10 font-weight-500 font-size-120" :class="'w5-status-color-' + status">{{ serviceStatus['status'] | capitalize }} <font-awesome-icon icon="clock" style="margin-left: 6px" /></span>
					<span v-else class="margin-right-10 font-weight-500 font-size-120" :class="'w5-status-color-' + status">{{ serviceStatus['status'] | capitalize }}</span>
				</div>
				<template v-else>
					<img src="../../assets/img/puzzle.png" class="w5-empty-table-img" />
					<br>
					<span class="w5-empty-table-hint">{{ 'main/empty_table' | ftc }}</span>
				</template>
			</div>
		</template>
		<!-- нет активного процесса и есть права -->
		<template v-else>
			<!-- блок VNC и показа данных -->
			<div class="tab-pane-command-wrapper">
				<h4>{{ 'service/vnc_button_header' | ftc }}</h4>
				<p v-withSafeTags="localeFtc('service/vnc_button_description')"></p>

				<div class="w5-access-tab">
					<!-- пароль -->
					<div class="w5-access-tab-label">{{ 'main/password' | ftc }}: </div>
					<div class="w5-access-tab-value" :style="isDataShown ? 'color: black' : false" id="shownPassword" ref="passwordRef">{{ passwordForShow }}</div>
					<div v-show="!isDataShown" class="w5-access-tab-button">
						<font-awesome-icon icon="eye" :class="{ 'disable': !Access || Status !== 'active' }" :title="'main/show_data' | ftc" @click="showPassword" />
					</div>
					<div v-show="isDataShown && passwordForShow" class="w5-access-tab-button">
						<font-awesome-icon icon="copy" :title="'main/copy_to_clipboard' | ftc" @click="copyPassword" />
					</div>
					<span class="clearfix"></span>
				</div>

				<div v-show="isDataShown" class="w5-access-tab">
					<!-- хост -->
					<div class="w5-access-tab-label">{{ 'server/server' | ftc }}: </div>
					<div class="w5-access-tab-value" :style="isDataShown ? 'color: black' : false" id="shownHost">{{ hostForShow }}</div>
				</div>

				<div v-show="isDataShown" class="w5-access-tab">
					<!-- порт -->
					<div class="w5-access-tab-label">{{ 'main/port VNC' | ftc }}: </div>
					<div class="w5-access-tab-value" :style="isDataShown ? 'color: black' : false" id="shownPort">{{ portForShow }}</div>
				</div>

				<div class="hidden-xs margin-top-10"></div>

				<div class="btn btn-submit tab-command-button" :class="{ 'disable': !Access || Status !== 'active' }" @click="vnc">
					<font-awesome-icon icon="terminal" class="hidden-xs" />
					{{ 'service/vnc' | ftc }}
				</div>

			</div>

			<!-- блок изменение пароля -->
			<div class="tab-pane-command-wrapper">
				<h4>{{ 'service/password_change_button_header' | ftc }}</h4>
				<p v-withSafeTags="localeFtc('service/password_change_button_description')"></p>
							
				<div class="btns-block">
					<!-- кнопка изменения пароля VNC -->
					<div class="btn btn-submit tab-command-button" :class="{ 'disable': !Access || Status !== 'active' || !passwordType || !passwordType.vnc }" @click="changePassword('vnc')">
						<font-awesome-icon icon="random" class="hidden-xs" />
						{{ 'service/password_change' | ftc }} VNC
					</div>

					<!-- кнопка изменения пароля root -->
					<div class="btn btn-submit tab-command-button" :class="{ 'disable': !Access || Status !== 'active' || !passwordType || !passwordType.root }" @click="changePassword('root')">
						<font-awesome-icon icon="random" class="hidden-xs" />
						{{ 'service/password_change' | ftc }} root
					</div>
				</div>
			</div>
		</template>
	</div>

	<!-- диалог изменения пароля -->
	<transition name="modal">
		<div v-show="showPasswordModal" @mousedown="maskModalFlag = true" @mouseup="() => this.hidePasswordModal(false)" class="modal-mask">
			<div class="modal-wrapper">
				<div class="modal-container" @mousedown.stop="maskModalFlag = false" @mouseup.stop="maskModalFlag = false">

					<!-- заголовок -->
					<div class="modal-header">
						<button type="button" class="close" @click="hidePasswordModal">&times;</button>
						<span class="font-weight-500">{{ 'service/password_change' | ftc }} {{ String(passwordTypeSelected).toUpperCase() }}</span>
					</div>

					<!-- тело диалога -->
					<div class="modal-body">
						<div v-if="passwordWarning" class="w5-form-row">
							<div class="alert alert-warning font-size-90 margin-0 full-width" v-withSafeTags="localeFtc(passwordWarning)"></div>
						</div>

						<div class="w5-form-row">
							<Field
								:isVisibleRow="true"
								crud="vds"
								action="view"
								v-model="passwordValue"
								:Field="passwordField"
								:removeRightPadding="true"
								:fieldInModal="true"
								@focus="onFocusPassword"
								@enterKeyDown="passwordChange" />
						</div>
					</div>

					<!-- подвал -->
					<div class="modal-footer">
						<span class="btn btn-submit pull-right" @click="passwordChange">{{ 'service/password_change' | ftc }}</span>
					</div>
				</div>
			</div>
		</div>
	</transition>

</div></template>

<script>
///////////////////////////////////////////////////////////////////////////////
import Helper from '@/helper/helper'
import Field from '@/components/elements/formfield'
import { EventBus } from '@/bus.js'
///////////////////////////////////////////////////////////////////////////////
export default {
	//=========================================================================
	// наименование
	//=========================================================================
	name: 'tabAccess',
	//=========================================================================
	// данные переденные родителем
	//=========================================================================
	props: [
		'access',
		'status',
		'serviceStatus',
		'vdsId',
		'active',
		'serviceFullName',
		'templateName',
		'vdsInfo',
		'parentError',
		'passwordType'
	],
	//=========================================================================
	// переменные
	//=========================================================================
	data() {
		return {
			// доступ
			Access: false,
			Status: null,
			Error: '',
			// текущий шаблон
			Template: '',
			// сообщение с ошибкой
			localErrorMessage: '',

			// диалог смены пароля
			showPasswordModal: false,
			passwordWarning: '',
			rebootWarning: '',
			passwordValue: '',
			passwordField: {
				'required': true,
				'type': 'password',
				'title': 'main/new_password',
				'_field_name': 'newPassword',
				'_visible': true,
				'generator': true,
				'_errMsg': ''
			},

			// значение видимого пароля
			passwordForShow: '●●●●●●●●●●',
			hostForShow: '●●●●●●●●●●',
			portForShow: '●●●●●',

			// данные VNC
			dataVNC: false,

			// выбранный тип пароля
			passwordTypeSelected: null
		}
	},
	//=========================================================================
	// вычисляемые свойства
	//=========================================================================
	computed: {
		isDataShown() {
			return this.portForShow !== '●●●●●'
		},
		serviceInfo() {
			if (this.vdsInfo && this.vdsInfo.service && this.vdsInfo.service.service_data && this.vdsInfo.service.service_data.value)
				return this.vdsInfo.service.service_data.value
			return null
		}
	},
	//=========================================================================
	// при создании компонента
	//=========================================================================
	created() {
		this.Access = this.access
		this.Status = this.status
		this.Template = this.templateName
		this.Error = this.parentError

		this.maskModalFlag = false

		// если название шаблона не содержит "windows" и "freebsd" - добавим предупреждение о перезагрузке
		// if (this.Template.toLowerCase().indexOf('windows') < 0 && this.Template.toLowerCase().indexOf('freebsd') < 0)
		// теперь это нужно показывать в любом случае
		this.passwordWarning = this.localeFtc('service/reboot_warning')

		// описание смены пароля
		this.rebootWarning = 'service/change_password_for_vnc'
		// для линуксов еще и пароль рута
		if (this.Template.toLowerCase().indexOf('centos') >= 0 ||
			this.Template.toLowerCase().indexOf('ubuntu') >= 0 ||
			this.Template.toLowerCase().indexOf('debian') >= 0)
			this.rebootWarning = 'service/change_password_for_vnc_linux'

		// проверим - может просят вызвать какую то функцию
		if (window && window.sessionStorage)
		{
			let func = window.sessionStorage.getItem('callFunction')
			window.sessionStorage.removeItem('callFunction')
			if (func && func in this)
				this.$nextTick(() => this[func]())
		}
	},
	//=========================================================================
	// после того как компонент смонтирован
	//=========================================================================
	mounted() {
		// навешиваем обработчик на нажатие клавиш
		document.addEventListener('keydown', this.keyDownHandler)
	},
	//=========================================================================
	// перед уничтожением компонента
	//=========================================================================
	beforeDestroy() {
		// отписка
		document.removeEventListener('keydown', this.keyDownHandler)
	},
	//=========================================================================
	// методы компонента
	//=========================================================================
	methods: {
		//---------------------------------------------------------------------
		// обработка клавиш
		//---------------------------------------------------------------------
		keyDownHandler(e) {
			// закрытие всех диалогов
			if (e.keyCode === 27 && this.active)
			{
				e.preventDefault()
				this.hidePasswordModal()
			}
		},
		//---------------------------------------------------------------------
		// VNC
		//---------------------------------------------------------------------
		// клик по кнопке в панеле
		vnc(e) {
			// проверка
			if (!this.Access || this.Status !== 'active') return
			// если у родителя ошибка - ничего не делаем
			if (this.Error) return
			// обнуляем сообщения
			this.localErrorMessage = ''
			// если не заданы ID и название - ничего не делаем
			if (!this.vdsId || !this.serviceFullName)
			{
				this.localErrorMessage = 'VNC: service/not_found'
				return
			}

			// ID опеределен - открываем новое окно
			let _this = this
			window.getW5 = function() {
				// готовим функцию для дочернего окна
				return {
					getData: function(_Success, _Error) {
						// если данные есть в кеше
						if (_this.dataVNC)
						{
							_Success(_this.dataVNC['vnc']['host'], _this.dataVNC['vnc']['port'], _this.dataVNC['vnc']['password'], _this.serviceFullName, _this.serviceInfo)
							return true
						}
						// запрос VNC-данных
						_this.$http.get(_this.APIServerUrl + '/service/vnc/' + _this.vdsId).then(
							// если данные успешно получены
							resGet => {
								let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
								// получили требуемые данные
								if (_dt && _dt['status'] === 'ok' && _dt['vnc'] &&
									_dt['vnc']['host'] && _dt['vnc']['port'] && _dt['vnc']['password'])
								{
									_this.dataVNC = Object.assign({}, _dt)
									_Success(_dt['vnc']['host'], _dt['vnc']['port'], _dt['vnc']['password'], _this.serviceFullName, _this.serviceInfo)
									return true
								}

								// получили ошибку
								if (_dt && _dt['status'] === 'error')
								{
									// сообщение по умолчанию
									let _err = 'VNC: ' + _this.localeFtc('main/no_data')
									// если есть "title"
									if ('title' in _dt) _err = _this.localeFtc(_dt['title'])
									// если есть "content"
									if ('content' in _dt) _err = _this.localeFtc(_dt['content'])

									_Error(_err)
									return false
								}

								// получили что то не то...
								_Error('VNC: ' + _this.localeFtc('main/no_data'))
								return false
							},
							// не удалось получить данные или сервер вернул ошибку
							resGet => {
								let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
								// сообщение по умолчанию
								let _err = 'VNC: ' + _this.localeFtc('main/no_data')
								// если есть "title"
								if (_dt && 'title' in _dt) _err = _this.localeFtc(_dt['title'])
								// если есть "content"
								if (_dt && 'content' in _dt) _err = _this.localeFtc(_dt['content'])

								_Error(_err)
								return false
							}
						) // get
					} // getData
				} // return
			} // window.getW5

			// открываем вкладку
			window.open('/static/novnc/start.html?v=05', '_blank')
		},
		//---------------------------------------------------------------------
		// смена пароля
		//---------------------------------------------------------------------
		// клик по кнопке в панеле (вызов диалога)
		changePassword(type) {
			if (!this.Access || this.Status !== 'active' || !this.passwordType || !this.passwordType[type] || this.Error) return
			this.localErrorMessage = ''
			this.passwordValue = ''
			this.passwordField['_errMsg'] = ''
			this.passwordTypeSelected = type
			EventBus.$emit('w5-body-scroll-disable')
			this.showPasswordModal = true
		},
		// закрытие диалога
		hidePasswordModal(forceClose = true) {
			if (!forceClose)
			{
				// если это просто выход мыши за пределы даилога, например
				// при выделении мышью
				if (!this.maskModalFlag) return
			}

			EventBus.$emit('w5-body-scroll-enable')
			this.showPasswordModal = false
			this.hideModalMask()
		},
		onFocusPassword() {
			// чистим ошибку если есть
			this.passwordField['_errMsg'] = ''
		},
		// непосредственное изменение пароля
		passwordChange() {
			// еще раз проверим доступ
			if (!this.Access || this.Status !== 'active' || !this.passwordTypeSelected || !this.passwordType || !this.passwordType[this.passwordTypeSelected] || this.Error) return
			// если есть ошибка
			if (this.passwordField['_errMsg'] !== '') return
			// пустой пароль нельзя
			if (this.passwordValue.trim().length === 0)
			{
				this.passwordField['_errMsg'] = 'validators/error_req'
				return
			}
			// все в порядке - начинаем менять пароль
			// формируем URL
			let _url = this.APIServerUrl + '/service/update/' + this.vdsId
			// начинаем двойной запрос
			this.$http.get(_url).then(
				// положительный ответ
				resGet => {
					// получаем ответ
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// если ответ корректный
					if (_dt && _dt['_csrf'] && _dt['model'] && _dt['status'] === 'form')
					{
						// формируем POST-параметры
						let _post = { '_csrf': _dt['_csrf'] }
						_post[_dt['model']] = {
							'password': this.passwordValue.trim(),
							'password_type': this.passwordTypeSelected,
							'reinstall': 0
						}
						// производим запрос POST
						this.$http.post(_url, Helper.toFormData(_post)).then(
							// успешный ответ сервера
							resPost => {
								_dt = resPost && resPost.data && typeof resPost.data === 'object' ? resPost.data : false
								// если ошибки нет
								if (_dt && _dt['status'] === 'ok')
								{
									// закроем диалог
									this.hidePasswordModal()
									// установим успешное сообщение
									this.$emit('successMessage', 'service/password запущено...')
									// на этом все
									return
								}

								// если указана какая то ошибка
								if (_dt && _dt['status'] === 'error')
								{
									// ошибка по умолчанию
									this.passwordField['_errMsg'] = this.localeFtc('service/password_error')
									// если что то передали
									if (_dt['fields'] && _dt['fields']['password'])
									{
										if (Array.isArray(_dt['fields']['password']))
										{
											if (_dt['fields']['password'].length)
												this.passwordField['_errMsg'] = this.localeFtc(_dt['fields']['password'][0])
										}
										else
										{
											this.passwordField['_errMsg'] = this.localeFtc(_dt['fields']['password'])
										}
									}
									return
								}

								// закроем диалог
								this.hidePasswordModal()
								// иная ошибка
								this.localErrorMessage = this.formatRequestError(resPost)
							},
							// отрицательный ответ сервера
							resPost => {
								// закроем диалог
								this.hidePasswordModal()
								// ошибка сервера
								this.localErrorMessage = this.formatRequestError(resPost)
							}
						)

						// на этом все
						return
					}

					// закроем диалог
					this.hidePasswordModal()
					// ошибка формата ответа
					this.localErrorMessage = this.formatRequestError(resGet)
				},
				// отрицательный ответ
				resGet => {
					// закроем диалог
					this.hidePasswordModal()
					// ошибка сервера
					this.localErrorMessage = this.formatRequestError(resGet)
				}
			)
		},
		//---------------------------------------------------------------------
		// копирование пароля в буфер
		//---------------------------------------------------------------------
		copyPassword() {
			// еще раз проверим доступ
			if (!this.Access || this.Status !== 'active' || !this.vdsId) return
			// если у родителя ошибка - ничего не делаем
			if (this.Error) return
			// если есть данные в кеше
			if (this.dataVNC)
			{
				let el = this.$refs['passwordRef']
				let ok = Helper.copyToClipboard(el)
				if (ok)
					this.$emit('successMessage', 'main/copied_to_clipboard')
			}
		},
		//---------------------------------------------------------------------
		// показ пароля
		//---------------------------------------------------------------------
		showPassword() {
			// еще раз проверим доступ
			if (!this.Access || this.Status !== 'active' || !this.vdsId) return
			// если у родителя ошибка - ничего не делаем
			if (this.Error) return
			// если есть данные в кеше
			if (this.dataVNC)
			{
				// показываем данные
				this.passwordForShow = this.dataVNC['vnc']['password']
				this.hostForShow = this.dataVNC['vnc']['host']
				this.portForShow = this.dataVNC['vnc']['client_port']
				return
			}

			// запрос VNC-данных
			this.$http.get(this.APIServerUrl + '/service/vnc/' + this.vdsId).then(
				// если данные успешно получены
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// получили требуемые данные
					if (_dt && _dt['status'] === 'ok' && _dt['vnc'] &&
						_dt['vnc']['host'] && _dt['vnc']['client_port'] && _dt['vnc']['password'])
					{
						// показываем данные
						this.passwordForShow = _dt['vnc']['password']
						this.hostForShow = _dt['vnc']['host']
						this.portForShow = _dt['vnc']['client_port']
						// сохраним в кеше
						this.dataVNC = Object.assign({}, _dt)
						return
					}

					// получили ошибку
					if (_dt && _dt['status'] === 'error')
					{
						// сообщение по умолчанию
						let _err = this.localeFtc('main/no_data')
						// если есть "title"
						if ('title' in _dt) _err = this.localeFtc(_dt['title'])
						// если есть "content"
						if ('content' in _dt) _err = this.localeFtc(_dt['content'])

						this.localErrorMessage = _err
						return
					}

					// получили что то не то...
					this.localErrorMessage = this.localeFtc('main/no_data')
					return
				},
				// не удалось получить данные или сервер вернул ошибку
				resGet => {
					let _dt = resGet && resGet.data && typeof resGet.data === 'object' ? resGet.data : false
					// сообщение по умолчанию
					let _err = this.localeFtc('main/no_data')
					// если есть "title"
					if (_dt && 'title' in _dt) _err = this.localeFtc(_dt['title'])
					// если есть "content"
					if (_dt && 'content' in _dt) _err = this.localeFtc(_dt['content'])

					this.localErrorMessage = _err
					return
				}
			) // get
		},
		//---------------------------------------------------------------------
		// сброс данных
		//---------------------------------------------------------------------
		dropData() {
			this.dataVNC = false
			this.passwordForShow = '●●●●●●●●●●'
			this.hostForShow = '●●●●●●●●●●'
			this.portForShow = '●●●●●'
		}

		//---------------------------------------------------------------------
	},
	//=========================================================================
	// наблюдатель
	//=========================================================================
	watch: {
		'access': function(access) {
			this.Access = access
			this.dropData()
		},
		'status': function(status) {
			this.Status = status
			this.dropData()
		},
		'templateName': function(templateName) {
			this.Template = templateName
			// если название шаблона не содержит "windows" и "freebsd" - добавим предупреждение о перезагрузке
			/*
			if (this.Template.toLowerCase().indexOf('windows') < 0 ||
				this.Template.toLowerCase().indexOf('freebsd') < 0)
			*/
			// теперь это нужно показывать в любом случае
			this.passwordWarning = this.localeFtc('service/reboot_warning')

			// описание смены пароля
			this.rebootWarning = 'service/change_password_for_vnc'
			// для линуксов еще и пароль рута
			if (this.Template.toLowerCase().indexOf('centos') >= 0 ||
				this.Template.toLowerCase().indexOf('ubuntu') >= 0 ||
				this.Template.toLowerCase().indexOf('debian') >= 0)
				this.rebootWarning = 'service/change_password_for_vnc_linux'

			this.dropData()
		},
		'serviceFullName': function(serviceFullName) {
			this.fullName = serviceFullName
			this.dropData()
		},
		'active': function(value) {
			this.dropData()
		},
		'parentError': function(value) {
			this.Error = value
		}
	},
	//=========================================================================
	// используемые компоненты
	//=========================================================================
	components: {
		Field
	}
	//=========================================================================
}
///////////////////////////////////////////////////////////////////////////////
</script>

<style>
.w5-access-tab {
	display: flex
}
.w5-access-tab-label {
	float: left;
	width: 80px;
	font-weight: 400;
	line-height: 30px;
}
.w5-access-tab-value {
	float: left;
	width: auto;
	color: #ccc;
	font-weight: 300;
	font-size: 14px;
	line-height: 30px;
}
.w5-access-tab-button {
	float: left;
	width: 40px;	
	line-height: 30px;
	margin-left: 20px;
}
.tab-pane-command-wrapper svg.fa-eye,
.tab-pane-command-wrapper svg.fa-copy {
	color: #999;
	cursor: pointer;
	transition: color 0.2s;
}
.tab-pane-command-wrapper svg.fa-eye:hover,
.tab-pane-command-wrapper svg.fa-copy:hover {
	color: #333;
}

.btns-block {
	display: flex;
}

.btns-block > .tab-command-button {
	width: 230px;
}

.btns-block > .btn:first-of-type {
	margin-right: 20px;
}

@media screen and (max-width: 767px) {
	.btns-block {
		flex-direction: column;
	}

	.btns-block > .btn:first-of-type {
		margin-right: 0;
		margin-bottom: 10px;
	}
}

</style>



// WEBPACK FOOTER //
// access.vue?635f37af